import { render, staticRenderFns } from "./Editais.vue?vue&type=template&id=3be2d4b5&scoped=true"
import script from "./Editais.vue?vue&type=script&lang=js"
export * from "./Editais.vue?vue&type=script&lang=js"
import style0 from "./Editais.vue?vue&type=style&index=0&id=3be2d4b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be2d4b5",
  null
  
)

export default component.exports